import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

export const useQueryParams = () => {
  const { search } = useLocation();
  const params = useMemo(() => qs.parse(search.slice(1)), [search]);
  return params;
};
